
export class Organization {
    public id: number;
    public name: string;
    public address: string;
    public nip: string;
    public status?: number;
    public rekbots?: [];

    constructor(
        id: number, 
        name: string, 
        address: string, 
        nip: string, 
        rekbots?: [],
        status?: number
        ) {
        this.id = id;
        this.name = name;
        this.address = address;
        this.nip = nip;
        this.rekbots = rekbots; 
        this.status = status; 
    }
}